module.exports = __webpack_public_path__ + "static/media/galerija_2023 (2).a9b706c6.JPG";